var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zv-page"},[_c('div',{staticClass:"zv-content"},[_c('div',{staticClass:"zv-block"},[_c('zv-table',{ref:"dataTable",attrs:{"table":_vm.table}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }